export enum StatusCode {
  OK = 0,
  UNAUTHENTICATED = 16,
}
